module.exports = __webpack_public_path__ + "54cf98f5/img/scraper-icon.df6ccde5.svg";